export default class {
  static gtmUid = 'GTM-NVPBM8T';
  static gaMeasurementId = 'G-M5RG8RGKB5';

  static load() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { dataLayer.push(arguments) };

    dataLayer.push({
      'userId': Traus.company.user.id,
      'userEmail': Traus.company.user.email,
      'companyName': Traus.company.name,
    });

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',this.gtmUid);
  }

  static trackGoogleAnalytics = (event) => {
    gtag('config', this.gaMeasurementId, {
      'cookie_flags': 'max-age=7200;secure;samesite=none'
    })
  }
}